import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { DynamicComponentService } from '@shared/components/atomics/body-loading/dynamic-component-service.service';
import { TrunkBaseConfigurationService } from '@core/services/trunk-base-configuration/trunk-base-configuration.service';
import { Router } from '@angular/router';
import { QueryBuilderExcludedUrlsLoading } from '@features/query-builder/query-builder-exluded-urls-loading';
import { ConfigurationIAExcludedUrlsLoading } from '@modules/configuration-ia/configuracion-ia-excluded-urls-loading';
import { ProvidersAiExludedUrlsLoading } from '@features/providers-ai/providers-ai-excluded-urls-loading';

@Injectable()
export class BodyLoadingInterceptor implements HttpInterceptor {
  private activeRequests = 0;

  private validRoutes = [
    '/configuration-ia',
    '/query-builder',
    '/bot-ia-example'
  ];
  private excludedRoutes = [
    ...QueryBuilderExcludedUrlsLoading,
    ...ConfigurationIAExcludedUrlsLoading,
    ...ProvidersAiExludedUrlsLoading
  ];

  constructor(
    private dynamicComponentService: DynamicComponentService,
    private trunkBaseConfigurationService: TrunkBaseConfigurationService,
    private router: Router,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.trunkBaseConfigurationService.CIABodyLoadingRequests || !this.belongsToValidContext()) {
      return next.handle(req);
    }
    if(this.isExcludedRoute(req)) return next.handle(req);

    this.activeRequests++;
    if (this.activeRequests === 1) {
      this.dynamicComponentService.showBodyLoading();
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests = Math.max(this.activeRequests - 1, 0);
        if (this.activeRequests === 0) {
          this.dynamicComponentService.destroyBodyLoading();
        }
      })
    );
  }

  private belongsToValidContext(): boolean {
    return this.validRoutes.some(route => this.router.url.includes(route));
  }
  private isExcludedRoute(req: HttpRequest<any>): boolean {
    return this.excludedRoutes.some(excluded => req.url.includes(excluded.trim()));
  }
}